import apiClient from './apiClient';

export const fetchArticleComments = async (articleId, params = {}) => {
  const query = new URLSearchParams(params).toString();
  const url = `/comments/article/${articleId}${query ? `?${query}` : ''}`;
  const response = await apiClient.get(url);
  return response.data;
};

export const submitComment = async (articleId, payload) => {
  const response = await apiClient.post(`/comments/article/${articleId}`, payload);
  return response.data;
};
